<template>
    <div
        v-if="volwasssenenTarief.globaal > 0"
        class="borderbottom regelpadding lineheight32 height32"
        style="border-bottom: none"
    >
        <div
            v-on:mouseenter="mouseEnter"
            v-on:mouseleave="mouseLeave"
            class="extraSpace label floatleft bold uppercase "
        >
            <span class="floatleft">Fooien/Services:</span>
            <span class="floatleft marginleft5">
                <font-awesome-icon class="cruiseinfoimg" icon="info-circle" />
            </span>
        </div>

        <div
            v-show="showPopup"
            v-html="content"
            class="div_extra_informatie"
            style="position: absolute; z-index: 999999;left: 150px; float:left"
        ></div>

        <div class="width 100">
            <transition name="fade" appear> </transition>
            <div class="breakSpace" style="float:left">
                <input
                    style="float:left; margin-top: 9px;"
                    v-model="fooienType"
                    type="radio"
                    class="marginright5"
                    name="fooien"
                    value="exclusief"
                    id="fooien_exclusief"
                />
                <label for="fooien_exclusief">
                    Te voldoen op schip
                </label>
            </div>
            <div>
                <input
                    style="float:left;margin-top: 9px;"
                    v-model="fooienType"
                    type="radio"
                    class="marginright5"
                    name="fooien"
                    value="inclusief"
                    id="fooien_inclusief"
                />
                <label for="fooien_inclusief">
                    Direct bij boeking voldoen
                    <span class="echo_fooien">
                        (&euro; {{ roundPrice(volwasssenenTarief.globaal) }}
                        p.p.)
                    </span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Fooien',
    data: function() {
        return {
            contentFallback: null,
            showPopup: false,
        }
    },
    methods: {
        mouseLeave: function() {
            this.showPopup = false
        },
        mouseEnter: function() {
            this.showPopup = true
        },

        numberWithCommas: function(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },

        roundPrice: function(price) {
            if (!price) return '-'
            if (isNaN(price)) return '?'
            let parsed = price.toFixed(2)
            return this.numberWithCommas(
                parsed
                    .split('.')
                    .join(',')
                    .replace(',00', ',-')
            )
        },
    },
    computed: {
        cruise: function() {
            return this.$store.state.cruise
        },
        show: function() {
            return this.cruise.tarief_drankenpakket_volwassenen > 0
        },
        content: function() {
            if (this.cruise.content_fooien !== '') {
                return this.cruise.content_fooien
            }
            return this.contentFallback
        },
        volwasssenenTarief: function() {
            return this.cruise.tarief_fooien_volwassenen
        },
        kinderenTarief: function() {
            return this.cruise.tarief_fooien_kinderen
        },
        babyTarief: function() {
            return this.cruise.tarief_fooien_baby
        },
        fooienType: {
            get: function() {
                return this.$store.state.fooienType
            },
            set: function(value) {
                this.$store.state.fooienType = value
            },
        },
        cabinSetup: function() {
            return this.$store.state.cabinSetup
        },

        cabinHasNonAdult: function() {
            let hasNonAdult = false

            this.cabinSetup.forEach(function(cabin) {
                if (cabin.kinderen > 0 || cabin.jeugd > 0 || cabin.baby > 0) {
                    hasNonAdult = true
                }
            })

            return hasNonAdult
        },
    },
}
</script>

<style scoped>
@media only screen and (max-width: 1100px) {
    .borderbottom .regelpadding .lineheight32 .height32 {
        width: auto;
    }
    .breakSpace {
        width: 100%;
    }
    .extraSpace {
        width: 100% !important;
    }
}
</style>
